module.exports = __webpack_public_path__ + "static/media/website.fdb1483d.svg";